import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState, useMemo } from "react";
import { CheckoutStep } from "@temp/core/config";
import { checkIfShippingRequiredForProducts } from "@utils/core";
import { isPriceEqual } from "@utils/money";
export var useCheckoutStepState = function useCheckoutStepState(items, checkout, payment, totalPrice) {
  var isShippingRequiredForProducts = checkIfShippingRequiredForProducts(items);
  var isCheckoutPriceEqualPaymentPrice = (payment === null || payment === void 0 ? void 0 : payment.total) && (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.net) && isPriceEqual(payment.total, totalPrice.net);

  var getMaxPossibleStep = function getMaxPossibleStep() {
    if (!(checkout === null || checkout === void 0 ? void 0 : checkout.id) && items) {
      // we are creating checkout during address set up
      return CheckoutStep.Address;
    }

    var isShippingAddressSet = !isShippingRequiredForProducts || !!(checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress);
    var isShippingMethodSet = !isShippingRequiredForProducts || !!(checkout === null || checkout === void 0 ? void 0 : checkout.shippingMethod);
    var isPaymentMethodSet = !!(payment === null || payment === void 0 ? void 0 : payment.id) && isCheckoutPriceEqualPaymentPrice;

    if (!isShippingAddressSet) {
      return CheckoutStep.Address;
    }

    if (!isShippingMethodSet) {
      return CheckoutStep.Shipping;
    }

    if (!isPaymentMethodSet) {
      return CheckoutStep.Payment;
    }

    return CheckoutStep.Review;
  };

  var getRecommendedStep = function getRecommendedStep(newMaxPossibleStep) {
    var isPaymentRecreateRequired = newMaxPossibleStep > CheckoutStep.Shipping && !isCheckoutPriceEqualPaymentPrice;

    if (isPaymentRecreateRequired && isShippingRequiredForProducts) {
      return CheckoutStep.Shipping;
    }

    if (isPaymentRecreateRequired) {
      return CheckoutStep.Payment;
    }

    return newMaxPossibleStep;
  };

  var maxPossibleStepActual = useMemo(function () {
    return getMaxPossibleStep();
  }, [items, checkout, payment, isShippingRequiredForProducts, isCheckoutPriceEqualPaymentPrice]);

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      maxPossibleStep = _useState2[0],
      setMaxPossibleStep = _useState2[1];

  var _useState3 = useState(getRecommendedStep(maxPossibleStep)),
      _useState4 = _slicedToArray(_useState3, 2),
      recommendedStep = _useState4[0],
      setRecommendedStep = _useState4[1];

  useEffect(function () {
    var newMaxPossibleStep = getMaxPossibleStep();
    var newRecommendedStep = getRecommendedStep(newMaxPossibleStep);

    if (maxPossibleStep !== newMaxPossibleStep) {
      setMaxPossibleStep(newMaxPossibleStep);
    }

    if (recommendedStep !== newRecommendedStep) {
      setRecommendedStep(newRecommendedStep);
    }

    return function () {
      setMaxPossibleStep(0);
      setRecommendedStep(0);
    };
  }, [checkout, items, payment, totalPrice]);
  return {
    recommendedStep: recommendedStep,
    maxPossibleStep: maxPossibleStepActual
  };
};